export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12832.b61d1520.jpg";